import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UsersTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function UserStatisticsTab() {
  const [statistics, setStatistics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingStat, setEditingStat] = useState(null);
  const [formData, setFormData] = useState({
    messages_today: '',
    questions_today: '',
    total_questions: '',
    answers_today: '',
    great_answers_today: '',
    total_mock: '',
    total_certs: '',
    total_testtasks: ''
  });

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/user-statistics`);
      setStatistics(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке статистики: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (stat) => {
    setEditingStat(stat);
    setFormData({
      messages_today: (stat.messages_today ?? 0).toString(),
      questions_today: (stat.questions_today ?? 0).toString(),
      total_questions: (stat.total_questions ?? 0).toString(),
      answers_today: (stat.answers_today ?? 0).toString(),
      great_answers_today: (stat.great_answers_today ?? 0).toString(),
      total_mock: (stat.total_mock ?? 0).toString(),
      total_certs: (stat.total_certs ?? 0).toString(),
      total_testtasks: (stat.total_testtasks ?? 0).toString()
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        messages_today: parseInt(formData.messages_today) || 0,
        questions_today: parseInt(formData.questions_today) || 0,
        total_questions: parseInt(formData.total_questions) || 0,
        answers_today: parseInt(formData.answers_today) || 0,
        great_answers_today: parseInt(formData.great_answers_today) || 0,
        total_mock: parseInt(formData.total_mock) || 0,
        total_certs: parseInt(formData.total_certs) || 0,
        total_testtasks: parseInt(formData.total_testtasks) || 0
      };
      
      await axios.put(`${API_URL}/api/user-statistics/${editingStat.id}`, payload);
      setEditingStat(null);
      setFormData({
        messages_today: '',
        questions_today: '',
        total_questions: '',
        answers_today: '',
        great_answers_today: '',
        total_mock: '',
        total_certs: '',
        total_testtasks: ''
      });
      fetchStatistics();
    } catch (err) {
      setError('Ошибка при обновлении статистики: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleCancel = () => {
    setEditingStat(null);
    setFormData({
      messages_today: '',
      questions_today: '',
      total_questions: '',
      answers_today: '',
      great_answers_today: '',
      total_mock: '',
      total_certs: '',
      total_testtasks: ''
    });
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить эту запись статистики?')) {
      try {
        await axios.delete(`${API_URL}/api/user-statistics/${id}`);
        fetchStatistics();
      } catch (err) {
        setError('Ошибка при удалении статистики: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="users-tab">
      <div className="tab-header">
        <h2>Статистика пользователей</h2>
      </div>

      {error && <div className="error-message">{error}</div>}

      {editingStat && (
        <div className="form-container">
          <h3>Редактировать статистику пользователя (ID: {editingStat.user_id})</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="messages_today">Сообщений за сегодня *</label>
              <input
                type="number"
                id="messages_today"
                value={formData.messages_today}
                onChange={(e) => setFormData({ ...formData, messages_today: e.target.value })}
                required
                min="0"
                placeholder="0"
              />
            </div>
            <div className="form-group">
              <label htmlFor="questions_today">Вопросов за сегодня *</label>
              <input
                type="number"
                id="questions_today"
                value={formData.questions_today}
                onChange={(e) => setFormData({ ...formData, questions_today: e.target.value })}
                required
                min="0"
                placeholder="0"
              />
            </div>
            <div className="form-group">
              <label htmlFor="total_questions">Всего вопросов *</label>
              <input
                type="number"
                id="total_questions"
                value={formData.total_questions}
                onChange={(e) => setFormData({ ...formData, total_questions: e.target.value })}
                required
                min="0"
                placeholder="0"
              />
            </div>
            <div className="form-group">
              <label htmlFor="answers_today">Ответов за сегодня</label>
              <input
                type="number"
                id="answers_today"
                value={formData.answers_today}
                onChange={(e) => setFormData({ ...formData, answers_today: e.target.value })}
                min="0"
                placeholder="0"
              />
            </div>
            <div className="form-group">
              <label htmlFor="great_answers_today">Отличных ответов за сегодня</label>
              <input
                type="number"
                id="great_answers_today"
                value={formData.great_answers_today}
                onChange={(e) => setFormData({ ...formData, great_answers_today: e.target.value })}
                min="0"
                placeholder="0"
              />
            </div>
            <div className="form-group">
              <label htmlFor="total_mock">Всего mock-собеседований</label>
              <input
                type="number"
                id="total_mock"
                value={formData.total_mock}
                onChange={(e) => setFormData({ ...formData, total_mock: e.target.value })}
                min="0"
                placeholder="0"
              />
            </div>
            <div className="form-group">
              <label htmlFor="total_certs">Всего сертификаций</label>
              <input
                type="number"
                id="total_certs"
                value={formData.total_certs}
                onChange={(e) => setFormData({ ...formData, total_certs: e.target.value })}
                min="0"
                placeholder="0"
              />
            </div>
            <div className="form-group">
              <label htmlFor="total_testtasks">Всего тестовых заданий</label>
              <input
                type="number"
                id="total_testtasks"
                value={formData.total_testtasks}
                onChange={(e) => setFormData({ ...formData, total_testtasks: e.target.value })}
                min="0"
                placeholder="0"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                Сохранить
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>ID пользователя</th>
              <th>Telegram ID</th>
              <th>Сообщений всего</th>
              <th>Вопросов сегодня</th>
              <th>Всего вопросов</th>
              <th>Ответов сегодня</th>
              <th>Отличных ответов сегодня</th>
              <th>Mock</th>
              <th>Сертификаты</th>
              <th>Тест-задания</th>
              <th>Избранные вопросы</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {statistics.length === 0 ? (
              <tr>
                <td colSpan="13" className="empty-state">
                  Нет записей статистики. Статистика создается автоматически при создании пользователя.
                </td>
              </tr>
            ) : (
              statistics.map((stat) => (
                <tr key={stat.id}>
                  <td>{stat.id}</td>
                  <td>{stat.user_id}</td>
                  <td>{stat.user_telegram_id || 'N/A'}</td>
                  <td>{stat.messages_today ?? 0}</td>
                  <td>{stat.questions_today ?? 0}</td>
                  <td>{stat.total_questions ?? 0}</td>
                  <td>{stat.answers_today ?? 0}</td>
                  <td>{stat.great_answers_today ?? 0}</td>
                  <td>{stat.total_mock ?? 0}</td>
                  <td>{stat.total_certs ?? 0}</td>
                  <td>{stat.total_testtasks ?? 0}</td>
                  <td>
                    {stat.favorite_question_ids && stat.favorite_question_ids.length > 0 
                      ? stat.favorite_question_ids.join(', ') 
                      : 'Нет избранных'}
                  </td>
                  <td>
                    <button
                      className="btn-icon btn-edit"
                      onClick={() => handleEdit(stat)}
                      title="Редактировать"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(stat.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UserStatisticsTab;
